import React from "react";
import { Button, Modal } from "semantic-ui-react";
import "./ModalConfirm.scss";

export function ModalConfirm(props) {
  const {
    title,
    content,
    show,
    onClose,
    onCloseText,
    onConfirm,
    onConfirmText,
    onDismiss,
    // Deshabilita el botón de confirmar (ej. falta elegir un motivo).
    confirmDisabled = false,
    size = "mini",
  } = props;

  return (
    <Modal
      className="modal-confirm"
      open={show}
      size={size}
      onClose={onDismiss}
      closeOnDimmerClick={!!onDismiss}
      closeOnEscape={!!onDismiss}
    >
      {title && <Modal.Header>{title}</Modal.Header>}
      {content && <Modal.Content>{content}</Modal.Content>}

      <Modal.Actions>
        {onDismiss && (
          <Button basic onClick={onDismiss}>
            Cancelar
          </Button>
        )}
        <Button negative onClick={onClose}>
          {onCloseText || "Cancelar"}
        </Button>
        <Button positive onClick={onConfirm} disabled={confirmDisabled}>
          {onConfirmText || "Aceptar"}
        </Button>
      </Modal.Actions>
    </Modal>
  );
}
